import "./width-keyframes.css"

import { useEffect, useLayoutEffect, useRef, useState } from "react"

const TimeProgress = ({ start, end }: { start: number; end: number }) => {
  const div = useRef<HTMLDivElement>(null)
  const transitionTime = useRef(end - Date.now())
  const startWidthPercentage = useRef(
    ((end - Date.now()) / (end - start)) * 100,
  )

  useLayoutEffect(() => {
    if (!div.current) return
    div.current.animate(
      [
        {
          width: startWidthPercentage.current + "%",
        },
        {
          width: 0,
        },
      ],
      {
        duration: transitionTime.current || 0,
        easing: "linear",
      },
    )
  }, [div, start])

  return <div ref={div} className="h-full rounded-xs bg-brand-primary" />
}

export const SecsTimer = ({ end }: { end: number }) => {
  const [timeLeft, setTimeLeft] = useState(() =>
    Math.round((end - Date.now()) / 1000),
  )
  const expired = timeLeft <= 0
  useLayoutEffect(() => {
    if (!expired) {
      const id = setInterval(() => {
        setTimeLeft((x) => x - 1)
      }, 1000)
      return () => clearInterval(id)
    }
  }, [expired])
  const timeLeftMins = Math.trunc(timeLeft / 60)
  const timeLeftSecs = timeLeft % 60

  return (
    <p className="text-xs-regular whitespace-nowrap text-primary">
      {timeLeftMins}m {timeLeftSecs}s
    </p>
  )
}

export const CreditRfqTimer = ({
  start,
  end,
  isSellSideView,
}: {
  start: number
  end: number
  isSellSideView: boolean
}) => {
  const [timerEnded, setTimerEnded] = useState(Date.now() >= end)

  useEffect(() => {
    if (!timerEnded) {
      const id = setInterval(() => {
        if (Date.now() >= end) {
          setTimerEnded(true)
        }
      }, 1000)
      return () => clearInterval(id)
    }
  }, [timerEnded, end])

  return timerEnded ? null : (
    <>
      {!isSellSideView && <SecsTimer end={end} />}
      <div className="mx-sm h-sm w-full rounded-xs">
        <TimeProgress start={start} end={end} />
      </div>
      {isSellSideView && <SecsTimer end={end} />}
    </>
  )
}
